import {Directive, EventEmitter, Input, Output, forwardRef} from '@angular/core';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors} from "@angular/forms";
import {delay, Observable, of, switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {UserService} from "../services/user.service";

@Directive({
    selector: '[appValidatePassword]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ValidatePasswordDirective),
            multi: true
        }
    ],
    standalone: false
})

export class ValidatePasswordDirective implements AsyncValidator {
  @Input('appValidatePassword') apiUrl: string = '';
  @Output() validatePasswordEvent = new EventEmitter<any>();

  constructor(private userService : UserService) {
  }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    console.log(control)
    if (!control.value || !control.dirty) {
      return of(null);
    }

    return of(control.value).pipe(delay(1000),
      switchMap((password) =>
        this.userService.validatePassword(this.apiUrl, password).pipe(map(response => {
          switch (response?.message) {
            case 'Invalid' : {
              return {passwordInValid: true}
            }
            case 'Valid': {
              return null;
            }
            default: {
              // invalid pattern
              return {error: response?.message};
            }
          }
        }))
      )
    );
  }
}
